import {useState} from 'react';

export function useSessionBoolean(key: string) {
  const [value, setValue] = useState(() => sessionStorage.getItem(key) === 'true');

  const set = (next: boolean) => {
    sessionStorage.setItem(key, String(next));
    setValue(next);
  };

  return [value, set] as const;
}
